import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadContextSummary as GetLeadContextSummaryQuery,
    GetLeadContextSummary_leadContextSummary as LeadContextSummary,
    GetLeadContextSummaryVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_CONTEXT_SUMMARY from '../queries/get-lead-context-summary.graphql';

export const useGetLeadContextSummary = (
    id: string
): {
    leadContextSummary: LeadContextSummary | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetLeadContextSummaryQuery,
        GetLeadContextSummaryVariables
    >(GET_LEAD_CONTEXT_SUMMARY, {
        variables: {
            id,
        },
    });

    return {
        leadContextSummary: data && data.leadContextSummary,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
